import ContratoInterceptor from '../ContratoInterceptor'
import { CalculadoraProvisao } from '../../../types/Provisao'

const api = new ContratoInterceptor()
    
export default {
    calculoProvisao(calculadora: CalculadoraProvisao) {
        return api.post('/calculadora/contrato', calculadora)
    }
}